var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-text-row"},[(_vm.row)?_c('div',{staticClass:"leading-snug max-w-5xl body",class:_vm.textSizes,domProps:{"innerHTML":_vm._s(_vm.row.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }